/**
 * NAD+ Science Section
 * Handles intersection observer for animation triggers
 */

class NADScienceSection {
  private section: HTMLElement;
  private observer: IntersectionObserver | null = null;
  
  constructor(section: HTMLElement) {
    this.section = section;
    this.init();
  }
  
  private init(): void {
    this.setupIntersectionObserver();
  }
  
  private setupIntersectionObserver(): void {
    this.observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          this.section.classList.add('nad-science-section--visible');
          this.observer?.unobserve(entry.target);
        }
      });
    }, {
      threshold: 0.2,
      rootMargin: '-10% 0px'
    });
    
    this.observer.observe(this.section);
  }

  public destroy(): void {
    if (this.observer) {
      this.observer.disconnect();
      this.observer = null;
    }
    this.section.classList.remove('nad-science-section--visible');
  }

  public static initializeAll(): NADScienceSection[] {
    const sections = document.querySelectorAll<HTMLElement>('.nad-science-section');
    return Array.from(sections).map(section => new NADScienceSection(section));
  }

  public static destroySection(section: HTMLElement): void {
    const instance = (section as any).__nadScienceSection;
    if (instance && instance.destroy) {
      instance.destroy();
    }
  }
}

// Export for initialization from main file
export { NADScienceSection };
